import { Sentiment } from '@sidecar-components/types'

export enum PillWeight {
  DEFAULT = 'default',
  WEAK = 'weak',
}

export interface PillProps {
  // Required - Adds more classes to the pill for specific use cases
  text: string
  // Optional - Adds more classes to the pill for specific use cases
  className?: string
  // Optional - Adds a data-testid param to the pill for Heap tracking and automated testing.
  testId?: string
  // Optional - Name of optional icon
  icon?: string
  // Optional - Color of pill
  sentiment?: Sentiment
  // Optional - Whether or not to truncate the text
  truncation?: boolean
  // Optional - Whether to use sentiment (default) or sentimentcontainer (weak) styles
  weight?: PillWeight
}
